/* eslint-disable */
import { container, request, storage } from '../foundation/index'

const env = process.env.fmt_env || 'dev'

const config = {
  env
}

const keyWithNamespacePrefix = key => {
  if (env === 'prd') {
    return key
  } else {
    return `${env}_${key}`
  }
}

const storagePrototype = Object.getPrototypeOf(storage)
const methods = Object.getOwnPropertyNames(storagePrototype)

methods.forEach(name => {
  const original = storagePrototype[name]

  if (typeof original === 'function') {
    if (
      name === 'getItem' ||
      name === 'getItemSync' ||
      name === 'setItem' ||
      name === 'setItemSync' ||
      name === 'removeItem' ||
      name === 'removeItemSync'
    ) {
      storagePrototype[name] = (key, value) => {
        key = keyWithNamespacePrefix(key)
        return original.call(storage, key, value)
      }
    }
  }
})
/**
 * util
 */

export { request, container, config, storage }
